import * as ReactDOM from 'react-dom';
import { Button } from '@progress/kendo-react-buttons';
import React, { ComponentPropsWithRef, useContext } from 'react';

import { GameDocumentContext } from '../../contexts/game-document';
import { DisplayLanguageContext } from '../../contexts/display-languages';
import { generateTitleById } from '../../utils/game-document/display-languages';

export interface AchievementDialogProps extends ComponentPropsWithRef<'div'> {
  imageUrl?: string;
  onMaskClick?: () => void;
  priorityQueueNumber?: number;
  onClose: () => void;
}

export const AchievementDialog = ({
  imageUrl,
  priorityQueueNumber,
  onClose,
  onMaskClick = () => {},
  ...props
}: AchievementDialogProps) => {
  const [gameDocument] = useContext(GameDocumentContext);
  const [displayLanguageContext] = useContext(DisplayLanguageContext);

  const stopOnClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
  };

  const zIndex = !priorityQueueNumber ? 1020 : 1020 * priorityQueueNumber!;

  return (
    <React.Fragment>
      {ReactDOM.createPortal(
        <div
          className={'achievement-dialog__mask'}
          style={{ zIndex: zIndex }}
          onClick={onMaskClick}>
          <div
            {...props}
            className={`achievement-dialog ${props.className ?? ''}`.trim()}
            onClick={stopOnClick}>
            {imageUrl && (
              <div className={'achievement-dialog__image'}>
                <img src={imageUrl} />
              </div>
            )}
            <div className={'achievement-dialog__body'}>{props.children}</div>
            <div className={'achievement-dialog__footer'}>
              <Button
                fillMode={'outline'}
                themeColor={'light'}
                onClick={onClose}>
                {generateTitleById(
                  '48bc820b-40e8-4624-8d46-b68e16013be6',
                  gameDocument,
                  displayLanguageContext.displayLanguageSelected.resources!,
                  'game'
                ) || 'Close'}
              </Button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </React.Fragment>
  );
};

export default AchievementDialog;
